import { createContext, useState } from 'react'
import GameModeChooseModal from '../components/GameModeChooseModal'

const GameDifficultyContext = createContext()

const GameModeContext = ({ children }) => {
  const [gameDifficultyMode, setGameDifficultyMode] = useState('')
  return (
    <GameDifficultyContext.Provider
      value={{ difficulty: gameDifficultyMode, setGameDifficultyMode }}>
      {gameDifficultyMode === '' && <GameModeChooseModal />}
      {gameDifficultyMode !== '' && children}
    </GameDifficultyContext.Provider>
  )
}

export default GameModeContext
export { GameDifficultyContext }
